import React, { useEffect, useState } from 'react';
import './App.css';
import PluginLoader from './PluginLoader';

const fetchPluginVersion = async (pluginId: string) => {
  const response = await fetch(
    `https://mercury-plugin-static-poc.deliveryherocare.com/${pluginId}/version.json`
  );
  return response.json();
};

const pluginId = 'ticket-detail';

function App() {
  const [pluginVersion, setPluginVersion] = useState<string | null>(null);
  const [pluginUrl, setPluginUrl] = useState<string | null>(null);

  useEffect(() => {
    fetchPluginVersion(pluginId).then((version) => {
      setPluginVersion(version.version);
      setPluginUrl(version.downloadUrl);
    });
  }, []);

  return (
    <div className='App'>
      <header className='App-header'>
        <h1>This is Oneview Mercury App Shell</h1>
      </header>
      {pluginUrl && (
        <div>
          <h2>
            Plugin: {pluginId}, <br /> version: {pluginVersion}.js
          </h2>
          <PluginLoader src={pluginUrl} />
        </div>
      )}
    </div>
  );
}

export default App;
